/* @flow */
import * as React from 'react';
import classnames from 'classnames';
import randomId from '../../../../javascripts/utils/random-id';

type Props = {
  icon: string,
  title?: string,
  desc?: string,
  viewBox?: string,
  className?: string,
  id?: string,
  paths?: Array<string>,
  focusable?: boolean,
  ariaHidden?: boolean,
};

const Icon = (props: Props): React.MixedElement => {
  const {
    id,
    icon,
    title,
    desc,
    className,
    viewBox = '0 0 200 200',
    ariaHidden,
    ...rest
  } = props;

  const classes = classnames(
    {
      icon: true,
      [`icon--${icon}`]: true,
    },
    className
  );

  const attributes = {
    id,
    viewBox,
    'aria-hidden': ariaHidden || (!title && 'true'),
    role: title && 'img',
    'aria-label': title,
  };

  return (
    <svg className={classes} {...attributes} {...rest}>
      {title && <title>{title}</title>}
      {desc && <desc>{desc}</desc>}
      <use xlinkHref={`#icon-${icon}`} />
    </svg>
  );
};

export default Icon;
